document.addEventListener('alpine:init', () => {
  Alpine.data('specName', ({ metaobjectHandle, country, language }) => ({
    name: metaobjectHandle,
    
    async init() {      
      const query = `
        query @inContext(country: ${country}, language: ${language}) {
          metaobject(handle: {type: "spec_name", handle: "${metaobjectHandle}"}) {
            id
            field(key: "pretty_spec_name") {
              value
            }
          }
        }
      `
      
      const response = await fetch('/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.themeVariables.settings.storefrontApiKey || '2a11880c514df7669d7ad32d05c82a5d'
        },
        body: JSON.stringify({ query })
      });
      
      const { data } = await response.json();

      this.name = data.metaobject.field.value;
    }
  }));
});